// Import Core
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
// Import Components
import NewsletterForm from './forms/NewsletterForm';
import Separator from '../ui/Separator';
import FormConfirmation from './forms/FormConfirmation';
// Import Utils
import { usePlaceholderImage } from '../../utils/useRandomPlaceholderImage';

const NewsletterCardStyling = styled.div`
	display: flex;
	gap: 80px;
	@media(max-width: 992px) {
		flex-direction: column;
		gap: 48px;
		width: 100%;
	}
	.placeholder-img {
		width: 50%;
		max-height: 400px;
		@media(max-width: 992px) {
			width: 100%;
		}
	}

	.newsletter-form-wrapper {
		h6 {
			color: var(--red);
			font-size: 36px;
		}
		p {
			padding-bottom: 16px;
		}
		#newsletter-form {
			padding-top: 16px;
			.form-group {
				display: block;

				.desktop-submit-btn {
					margin-top: 16px;
				}
			}
		}
		@media(max-width: 992px) {
			h6 {
			text-align: center;
			}
			p {
				text-align: center;
			}
		}
	}
	

`;

const NewsletterCardPopup = () => {
	const { randomPlaceholderImage} = usePlaceholderImage()
	const [hasSubmitted, setHasSubmitted] = useState(false);

	// Helper function to get cookie value
	const getCookie = (name) => {
		if (typeof document === 'undefined') return null;
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
		return null;
	};

	// Check if newsletter has been submitted on mount
	useEffect(() => {
		const cookieValue = getCookie('newsletter-submitted');
		if (cookieValue) {
			setHasSubmitted(true);
		}
	}, []);

	// Create queryParams for FormConfirmation component
	const queryParams = new URLSearchParams();
	queryParams.set('type', 'newsletter');
	queryParams.set('status', 'success');

	return (
		<NewsletterCardStyling className="newsletter-card-popup">
			<img src={randomPlaceholderImage} alt="Newsletter" className="placeholder-img" />
			<div className="newsletter-form-wrapper">
				<h6>NEWSLETTER</h6>
				<p>Join our mailing list to receive the latest  updates and travel inspiration.</p>
				<Separator color="red" />
				{hasSubmitted ? (
					<FormConfirmation queryParams={queryParams} />
				) : (
					<NewsletterForm onSuccess={() => setHasSubmitted(true)} />
				)}
			</div>
		</NewsletterCardStyling>
	);
};

export default NewsletterCardPopup;
